// * Bind dayjs to vue context

import Vue from 'vue'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import utc from 'dayjs/plugin/utc'

dayjs.extend(relativeTime)
dayjs.extend(LocalizedFormat)
dayjs.extend(utc)
Vue.prototype.$dayjs = dayjs

function retrieveBrowserLanguage() {
  let found = []

  if (typeof navigator !== 'undefined') {
    if (navigator.languages) {
      // chrome only; not an array, so can't use .push.apply instead of iterating
      for (const lang of navigator.languages) {
        found.push(lang)
      }
    }
    if (navigator.userLanguage) {
      found.push(navigator.userLanguage)
    }
    if (navigator.language) {
      found.push(navigator.language)
    }
  }

  return found.length > 0 ? found : undefined
}

export function setDayjsLocale($dayjs) {
  const browserLanguage = retrieveBrowserLanguage()
  if (browserLanguage) {
    const locale = browserLanguage[0].split('-')[0]
    import(
      /* webpackChunkName: "daysLocale/[request]", webpackExclude: /index\../  */
      `dayjs/locale/${locale}.js`
    ).then((response) => {
      $dayjs.locale(locale)
    })
  }
}
